// extracted by mini-css-extract-plugin
export var close = "UpsellModal-module__close___ePS39";
export var content = "UpsellModal-module__content___TTbPh";
export var feature = "UpsellModal-module__feature___et9GE";
export var features = "UpsellModal-module__features___L12h3";
export var logo = "UpsellModal-module__logo___R1OOd";
export var title = "UpsellModal-module__title___Sy0Aw";